module.exports = __webpack_public_path__ + "static/media/play.766b2f24.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/play.svg
// module id = 228
// module chunks = 0